export class CrudDataStats {
    currentPage = 1;
    rowCount = 0;
    pageSize = 0;
    pageCount = 0;
}